import axios from "axios";

export default {
	async store(payload) {
		return await axios.post("/profile/addresses", payload);
	},
	async update(id, payload) {
		return await axios.put("/profile/addresses/" + id, payload);
	},
	async delete(id) {
		return await axios.delete("/profile/addresses/" + id);
	},

};